import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 2000);
  };

  const newsletters = [
    {
      id: 1,
      title: "MedAgriCycle Monthly Update - December 2024",
      date: "December 15, 2024",
      description: "Latest developments in urban agriculture, waste valorization, and sustainable farming practices across Mediterranean regions.",
      image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Innovation Spotlight: Biochar Applications",
      date: "November 20, 2024",
      description: "Exploring the latest research and applications of biochar in improving soil health and carbon sequestration.",
      image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "Water Conservation Strategies in Urban Farming",
      date: "October 25, 2024",
      description: "Best practices and innovative solutions for efficient water use in urban agricultural systems.",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      title: "Circular Economy in Agriculture: Success Stories",
      date: "September 18, 2024",
      description: "Real-world examples of circular economy implementation in agricultural systems across Europe.",
      image: "https://images.unsplash.com/photo-1586771107445-d3ca888129ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <>
      <Navbar />
      <main className="main-content">
        <article className="article">
          {/* Hero Section */}
          <section className="hero-section" style={{
            background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            textAlign: 'center',
            padding: '80px 20px'
          }}>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
              <h1 style={{ 
                fontSize: 'clamp(2.5rem, 5vw, 4rem)', 
                fontWeight: '700', 
                marginBottom: '20px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Newsletter
              </h1>
              <p style={{ 
                fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)', 
                maxWidth: '800px', 
                margin: '0 auto',
                opacity: '0.95',
                lineHeight: '1.6'
              }}>
                Stay updated with the latest news, research findings, and innovations in sustainable urban agriculture
              </p>
            </div>
          </section>

          {/* Newsletter Archive Section */}
          <section style={{ padding: '80px 20px', backgroundColor: '#f8f9fa' }}>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
              <div style={{ 
                backgroundColor: '#fff', 
                padding: '60px 40px', 
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}>
                <h2 style={{ 
                  fontSize: '2.5rem', 
                  color: '#2c3e50', 
                  marginBottom: '30px',
                  textAlign: 'center'
                }}>
                  Newsletter Archive
                </h2>
                
                <p style={{ 
                  fontSize: '1.1rem', 
                  color: '#6c757d', 
                  textAlign: 'center', 
                  marginBottom: '50px',
                  maxWidth: '800px',
                  margin: '0 auto 50px'
                }}>
                  Browse our collection of monthly newsletters featuring the latest developments in MedAgriCycle research and implementation.
                </p>

                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                  gap: '30px',
                  marginTop: '50px'
                }}>
                  {newsletters.map((newsletter) => (
                    <div key={newsletter.id} style={{
                      border: '1px solid #e9ecef',
                      borderRadius: '8px',
                      backgroundColor: '#fff',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                    }}>
                      <div style={{
                        height: '200px',
                        backgroundImage: `url(${newsletter.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          bottom: '0',
                          left: '0',
                          right: '0',
                          background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                          padding: '20px'
                        }}>
                          <span style={{
                            color: '#fff',
                            fontSize: '0.9rem',
                            fontWeight: '600'
                          }}>
                            {newsletter.date}
                          </span>
                        </div>
                      </div>
                      
                      <div style={{ padding: '25px' }}>
                        <h3 style={{ 
                          fontSize: '1.2rem', 
                          color: '#2c3e50', 
                          marginBottom: '15px',
                          lineHeight: '1.4'
                        }}>
                          {newsletter.title}
                        </h3>
                        
                        <p style={{ 
                          color: '#6c757d', 
                          lineHeight: '1.6', 
                          marginBottom: '20px',
                          fontSize: '0.95rem'
                        }}>
                          {newsletter.description}
                        </p>
                        
                        <Link 
                          to={`/resources/newsletter/${newsletter.id}`}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            backgroundColor: '#96ca2d',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '6px',
                            fontSize: '0.9rem',
                            fontWeight: '600',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#7ba818';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#96ca2d';
                          }}
                        >
                          <i className="fas fa-envelope-open"></i> Read Newsletter
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Subscribe Section */}
          <section style={{ padding: '80px 20px', backgroundColor: '#fff' }}>
            <div className="container" style={{ maxWidth: '800px', margin: '0 auto' }}>
              <div style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '60px 40px', 
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <h2 style={{ 
                  fontSize: '2.2rem', 
                  color: '#2c3e50', 
                  marginBottom: '20px'
                }}>
                  Subscribe to Our Newsletter
                </h2>
                
                <p style={{ 
                  fontSize: '1.1rem', 
                  color: '#6c757d', 
                  marginBottom: '40px',
                  lineHeight: '1.6'
                }}>
                  Get the latest updates on MedAgriCycle research, events, and sustainable agriculture innovations delivered to your inbox.
                </p>

                {!isSubscribed ? (
                  <form onSubmit={handleSubscribe} style={{
                    display: 'flex',
                    gap: '15px',
                    maxWidth: '500px',
                    margin: '0 auto',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                  }}>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email address"
                      required
                      style={{
                        flex: '1',
                        minWidth: '250px',
                        padding: '15px 20px',
                        border: '2px solid #e9ecef',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = '#96ca2d';
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = '#e9ecef';
                      }}
                    />
                    <button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        padding: '15px 30px',
                        backgroundColor: isLoading ? '#6c757d' : '#96ca2d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        fontWeight: '600',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease',
                        minWidth: '120px'
                      }}
                      onMouseEnter={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.backgroundColor = '#7ba818';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.backgroundColor = '#96ca2d';
                        }
                      }}
                    >
                      {isLoading ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i> Subscribing...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane"></i> Subscribe
                        </>
                      )}
                    </button>
                  </form>
                ) : (
                  <div style={{
                    padding: '30px',
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                    borderRadius: '8px',
                    color: '#155724'
                  }}>
                    <i className="fas fa-check-circle" style={{ fontSize: '2rem', marginBottom: '15px' }}></i>
                    <h3 style={{ marginBottom: '10px' }}>Thank you for subscribing!</h3>
                    <p>You'll receive our next newsletter in your inbox.</p>
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Back to Resources */}
          <section style={{ padding: '40px 20px', backgroundColor: '#f8f9fa' }}>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
              <Link 
                to="/resources" 
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 30px',
                  backgroundColor: '#96ca2d',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#7ba818';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#96ca2d';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                ← Back to Resources
              </Link>
            </div>
          </section>
        </article>
      </main>
      <Footer />
    </>
  );
};

export default Newsletter;
